import { Button, CircularProgress, Paper, Typography } from '@mui/material';
import './availity-loader.scss';

interface AvailityLoaderProps {
  showLoader?: boolean;
  customMessage?: string;
  onCancel?: () => void;
  'test-id'?: string;
}

function AvailityLoader(props: AvailityLoaderProps) {
  const {
    showLoader,
    customMessage,
    onCancel,
    'test-id': testId = 'availity-loader',
  } = props;

  if (!showLoader) {
    return null;
  }

  return (
    <Paper className="availity-loader" elevation={1}>
      <div className="availity-loader__body" test-id={testId}>
        <CircularProgress size={28} />
        <div className="availity-loader__text">
          <Typography variant="subtitle2" component="p">
            {customMessage ?? 'Running Availity VOB'}
          </Typography>
          <Typography className="availity-loader__time" variant="body2" component="span">
            Waiting for Availity response
          </Typography>
          {onCancel ? (
            <Button
              className="availity-loader__cancel"
              variant="outlined"
              size="small"
              color="primary"
              type="button"
              onClick={onCancel}
              test-id={`${testId}-cancel`}
              sx={{ textTransform: 'none' }}
            >
              Cancel
            </Button>
          ) : null}
        </div>
      </div>
    </Paper>
  );
}

export default AvailityLoader;
